module.exports = __webpack_public_path__ + "img/china-CITIC.9ebbb913.png";